import { Injectable } from '@angular/core';
import { OrganismeService } from '../organisme/organisme.service';
import { FacturationService } from '../../../../common/services/facturation/facturation.service';

@Injectable({
  providedIn: 'root'
})
export class MapaService {

  constructor(
    public organismeService: OrganismeService,
    public facturationService: FacturationService
    ) { }
}
